/* tslint:disable */
/* eslint-disable */
/* @relayHash fcd307da59efb37d2061a43de84e9749 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Page = {
    offset?: number | null;
    limit?: number | null;
};
export type SecurityProgrammeFilter = {
    companyUUID?: string | null;
    name?: string | null;
};
export type App_SecurityProgrammes_QueryVariables = {
    page?: Page | null;
    filter?: SecurityProgrammeFilter | null;
};
export type App_SecurityProgrammes_QueryResponse = {
    readonly manager: {
        readonly " $fragmentRefs": FragmentRefs<"SecurityProgrammes_manager">;
    } | null;
};
export type App_SecurityProgrammes_Query = {
    readonly response: App_SecurityProgrammes_QueryResponse;
    readonly variables: App_SecurityProgrammes_QueryVariables;
};



/*
query App_SecurityProgrammes_Query(
  $page: Page
  $filter: SecurityProgrammeFilter
) {
  manager {
    ...SecurityProgrammes_manager
  }
}

fragment SecurityProgrammes_manager on Manager {
  company {
    securityProgrammes(page: $page, filter: $filter) {
      edges {
        uuid
        name
        createdAt
        downloadURL
      }
      pageInfo {
        total
        offset
        limit
        given
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Page",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "filter",
            "type": "SecurityProgrammeFilter",
            "defaultValue": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "App_SecurityProgrammes_Query",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SecurityProgrammes_manager",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "App_SecurityProgrammes_Query",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "manager",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Manager",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "company",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Company",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "securityProgrammes",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "filter",
                                            "variableName": "filter"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "page",
                                            "variableName": "page"
                                        }
                                    ],
                                    "concreteType": "SecurityProgrammePage",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SecurityProgramme",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "uuid",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "name",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "createdAt",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "downloadURL",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "pageInfo",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "total",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "offset",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "limit",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "given",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "App_SecurityProgrammes_Query",
            "id": null,
            "text": "query App_SecurityProgrammes_Query(\n  $page: Page\n  $filter: SecurityProgrammeFilter\n) {\n  manager {\n    ...SecurityProgrammes_manager\n  }\n}\n\nfragment SecurityProgrammes_manager on Manager {\n  company {\n    securityProgrammes(page: $page, filter: $filter) {\n      edges {\n        uuid\n        name\n        createdAt\n        downloadURL\n      }\n      pageInfo {\n        total\n        offset\n        limit\n        given\n      }\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'fe3e45aa6f0dd78649df15ae18343ab9';
export default node;
